import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { store } from './app/store';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { msalConfig } from './authConfig';
import getOpenFeatureProvider from './features/featureFlags/openFeatureProviders';

import './css/app.min.css';
import './css/appmediaqueries.min.css';
import './css/variables.css';
import './assets/fonts/tgicons/tg-icons.scss';
import './scss/fonts.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { OpenFeature } from '@openfeature/react-sdk';
import AnimatedRoute from './components/AnimatedComponents/AnimatedRoute';
import AppNavigation from './components/appNavBar/AppNavigation';
import ToastContainer from './components/Toast/ToastContainer';
import NetworkStatusToastTrigger from './features/networkStatus/NetworkStatusToastTrigger';
import NetworkStatusListener from "./features/networkStatus/NetworkStatusListener";

import { BrowserRouter } from 'react-router-dom';

const appRoot = 'root-dart';

/*
  MSW allows us to Mock API calls as part of the development process.
  It does not run in production builds.
 */
async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }
  const { worker } = await import('./mocks/browser');
  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}
await enableMocking();
const msalInstance = new PublicClientApplication(msalConfig);

OpenFeature.setProvider(getOpenFeatureProvider());
window.OpenFeature = OpenFeature;

console.log('Dart_build<');
ReactDOM.render(
  <React.StrictMode>
    <OpenFeatureProvider>
      <MsalProvider instance={msalInstance}>
        <Provider store={store()}>
          <BrowserRouter
            future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
          >
           
            <NetworkStatusListener />
            <ToastContainer />
            <NetworkStatusToastTrigger />
            
            <AnimatedRoute></AnimatedRoute>
            <AppNavigation />
          </BrowserRouter>
        </Provider>
      </MsalProvider>
    </OpenFeatureProvider>
  </React.StrictMode>,
  document.getElementById(appRoot)
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (localStorage.getItem('processenv') === 'dev') {
  console.log('Environment variables are: ', process.env);
}
